import { useUserStore } from "@/store/userStore";

export default defineNuxtRouteMiddleware((to) => {

  const userStore = useUserStore();
  
	// Set the layout on the route you are navigating _to_
	setPageLayout("mobile");
});
